// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, loginRequest } from "./authConfig";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

// Attempt silent SSO on app load — leverages existing Azure AD session
// from the other app so user is not prompted to login again
async function initializeSso() {
  await msalInstance.initialize();

  // Handle any redirect response first (e.g. returning from login)
  await msalInstance.handleRedirectPromise();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  } else {
    // No cached account — try silent SSO using existing Azure AD session cookie
    // Extract login_hint from URL if the other app passes it
    const params = new URLSearchParams(window.location.search);
    const loginHint = params.get("login_hint");

    try {
      const ssoRequest = {
        ...loginRequest,
        ...(loginHint && { loginHint }),
      };
      const response = await msalInstance.ssoSilent(ssoRequest);
      msalInstance.setActiveAccount(response.account);
    } catch (e) {
      // Silent SSO failed — user will see the login screen
      console.debug("SSO silent login not available:", e.message);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

initializeSso();